@switch (columnName) {
  @case ('department') {
    {{ element.departmentName }}
  }
  @case ('departments') {
    @for (department of element.departments; track $index) {
      <div>
        {{ department.name }}
      </div>
    }
    @for (departmentGroup of element.departmentGroups; track $index) {
      <div>
        {{ departmentGroup.name }}
      </div>
    }
  }
  @case ('color') {
    <app-ui-activity-color [color]="element.color" [label]="element.name"></app-ui-activity-color>
  }
  @default {
    {{ element[columnName] }}
  }
}
